import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PendingSubscriptionPage } from '../../../../components/pages/backoffice/common/pending-subscription-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/$subscriptionId/')({
  component: () => (
    <PermissionChecker requiredPermissions={[anyOfPermissions('subscription.read', 'subscription.read.relatedOnly')]}>
      <PendingSubscriptionPage />
    </PermissionChecker>
  ),
})
